export default {
    USER_MOBILE_DOSE_NOT_EXIST: "شماره موبایل وارد نشده.",
    USER_MOBILE_WRONG: "شماره موبایل شما نامعتبر است.",
  
    EMAIL_DOSE_NOT_EXIST: "ایمیل وارد نشده.",
    EMAIL_INVALID: "ایمیل نامعتبر است.",
  
    PASSWORD_DOSE_NOT_EXIST: "رمز عبور وارد نشده.",
    PASSWORD_INVALID: "رمز عبور نامعتبر است.",
  
    FIRST_NAME_DOSE_NOT_EXIST: "نام وارد نشده است.",
    FIRST_NAME_IS_WRONG: "نام شتباه است.",
    FIRST_NAME_DOSE_NOT_FARSI_CHAR: "نام فارسی نیست",
  
    LAST_NAME_DOSE_NOT_EXIST: "نام خانوداگی وارد نشده است.",
    LAST_NAME_IS_WRONG: "نام خانوداگی اشتباه است.",
    LAST_NAME_DOSE_NOT_FARSI_CHAR: "نام خانوداگی فارسی نیست.",
  
    EMAIL_REGISTERED_LAST: "ایمیل از قبل ثبت نام شده است.",
    MOBILE_REGISTERED_LAST: "موبایل از قبل ثبت نام شده است.",
  
    PASSWORD_MUST_HAVE_ONE_NUMBER: "رمز عبور باید حداقل دارای یک عدد باشد",
    PASSWORD_MUST_HAVE_ONE_LETTER: "رمز عبور باید حداقل دارای یک حرف باشد",
  
    PASSWORD_DOSE_NOT_MATCH: "رمز عبور و تکرار رمز عبور هم خوانی ندارند.",
  
    USER_REGISTER_SUCCESS: "ثبت شما با موفقیت انجام شد.",
    CREDENTIAL_DOSE_NOT_EXIST: "ایمیل یا شماره موبایل موجود نیست.",
    EMAIL_OR_PASSWORD_WRONG: "ایمیل یا رمز عبور اشتباه است.",
    MOBILE_OR_PASSWORD_WRONG: "موبایل یا رمز عبور اشتباه است.",
  
    SEND_CODE_CONFIRM_MOBILE_SUCCESS: "کد تایید ارسال شد.",
  
    USER_NOT_FOUNDED: "همه چنین کاربر وجود ندارد.",
  
    TOKEN_DOES_NOT_EXIST: "توکن موجود نیست.",
  };
  